module.exports = __webpack_public_path__ + "static/media/DOG FETCH 2.bfb7c7b1.gif";